export default "__VITE_ASSET__CklX5hEF__"